export const AnimationTypeEnum = {
  Complete: 'Complete',
  Positive: 'Positive',
  Negative: 'Negative',
} as const;

export type AnimationTypeEnum = typeof AnimationTypeEnum[keyof typeof AnimationTypeEnum];
